import React, { Suspense, useState } from "react";
import { render } from "react-dom";
import "../css/App.css";
import { CameraView } from "./CameraView";
import { Scene } from '../threed/Scene';
// import { HandPose } from '../threed/HandPose';


const AppBar = () => {
  return (
    <div className="header">
        <h2>Anguli</h2>
      </div>
  )
}

const App = () => {

  let landmarks = [];
  let annotations = [];
  let dXdt = 0;
  let previousAnnotation = {};

  const synchronizePredictions = (predictions) => {
    if(predictions.length > 0) {
      landmarks = predictions[0].landmarks
      annotations = predictions[0].annotations
      
      if(Object.keys(previousAnnotation).length > 0) {
          const prevIndexFinger = previousAnnotation.indexFinger
          const prevXCoord = prevIndexFinger[3][0];

          const indexFinger = annotations.indexFinger
          const xCoord = indexFinger[3][0];

          dXdt = xCoord - prevXCoord
        }
        previousAnnotation = annotations
      }
    }
  

  const getAnnotations = () => {
    return [annotations, dXdt];
  }

  return (
    <div className="container">
      <div className="top">
        <CameraView synchronizePredictions={synchronizePredictions}></CameraView>
      </div>
      <div className="bottom">
        <Scene getAnnotations={getAnnotations}></Scene>
      </div>
      {/* <div className="middle">
        <HandPose></HandPose>
      </div> */}
    </div>
  );
}

render(
  <>
    <AppBar/>
  <App/>

  </>,
  document.getElementById("root")
);

